import React, { useRef, useEffect, useState } from "react";

import edit from "../../assets/images/icons/edit-2.png";
import trash from "../../assets/images/icons/trash.png";

const MessageGroupItem = ({
  message,
  handleRemoveMessageGroups,
  handleEditMessageGroups,
}) => {
  const messageGroupRef = useRef(null);
  const [counter, setCounter] = useState(0);

  function calculateChildWidths() {
    const parentWidth = messageGroupRef.current.offsetWidth;
    // console.log("messageGroupRef.current", messageGroupRef.current)
    const messageDetailsDivs = messageGroupRef.current.querySelectorAll(
      ".individualMessageDetails"
    );

    let totalWidth = 20;
    let count = 0;

    messageDetailsDivs.forEach((div) => {
      const width = div.offsetWidth;
      // console.log("width", width);
      // console.log("parentWidth", parentWidth);
      // console.log("totalWidth", totalWidth);
      const total = totalWidth + width + 20;
      // console.log("total", total);
      totalWidth = total;
      if (total > parentWidth) {
        if (count === 0) {
          totalWidth = totalWidth + 60; // 60 width for show counter
        }
        // console.log("working", total > parentWidth, total, parentWidth);
        count = count + 1;
      }
    });
    setCounter(count);
  }

  useEffect(() => {
    if (messageGroupRef?.current && message) {
      calculateChildWidths();
    }
  }, [messageGroupRef, message]);

  const showItems = (message?.blocks?.length || 0) - (counter + 1);

  return (
    <ul className="individualRow tableContent">
      <li className="mesageSegmentTitle">{message.title}</li>
      <li
        className="messageSegmentBlocks customizedWraper"
        id="messageGroupListContent"
        ref={messageGroupRef}
      >
        {message?.blocks?.map((item, i) => {
          if (i > showItems) {
            return null;
          }
          return (
            <div className="individualMessageDetails" key={i}>
              {item?.map((newData, index) => (
                <span className="individualGroupDetails" key={index}>
                  {newData.contents}{" "}
                </span>
              ))}
            </div>
          );
        })}
        {counter && counter > 0 ? (
          <div className="individualMessageDetails counterInfoWrapers" onClick={() => handleEditMessageGroups(message)}>+ {counter}</div>
        ) : (
          ""
        )}
      </li>
      <li className="messageSegmentAction">
        <a
          onClick={() => handleEditMessageGroups(message)}
          style={{ marginRight: "20px" }}
        >
          <img height={20} alt="imagegroup" src={edit} className="actionImg" />
        </a>
        <a onClick={() => handleRemoveMessageGroups(message._id)}>
          <img height={20} alt="imagegroup" src={trash} className="actionImg" />
        </a>
      </li>
    </ul>
  );
};

export default MessageGroupItem;
